import { cardCache } from '../utils/weekReport.js'

// Derived responses only: unfinished inputs and offline write queues are kept.
export function clearAccountCache() {
  cardCache.uid = null
  cardCache.resp = null
  cardCache.at = 0
  try {
    for (const key of Object.keys(localStorage)) if (key.startsWith('zc:')) localStorage.removeItem(key)
  } catch { /* Storage may be unavailable. */ }
  if (typeof caches !== 'undefined') {
    return caches.keys().then(names => Promise.all(names.filter(n => /^api-cache(?:-|$)/.test(n)).map(n => caches.delete(n)))).catch(() => {})
  }
  return Promise.resolve()
}
